import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { ConfirmationModal } from '../../../components/ConfirmationModal';

interface IDeleteAnnotationsConfirmationModalProps {
  showDiscardModal: boolean;
  onDiscardConfirm: () => Promise<void>;
  onDiscardCancel: () => void;
}

export const DiscardAnnotationConfirmationModal = observer((props: IDeleteAnnotationsConfirmationModalProps): ReactElement => {
  return (
    <ConfirmationModal
      confirmationHeader={'discard_annotation'}
      confirmationQuestion={'are_you_sure_you_want_to_completely_remove_this_annotation'}
      onCancel={props.onDiscardCancel}
      onConfirm={props.onDiscardConfirm}
      showModal={props.showDiscardModal}
      confirmationYes={'discard'}
      loaderKey={'discard-annotation-button'}
    />
  );
});
